import React, { createContext, useState, useEffect, useContext, ReactNode } from 'react';
import apiClient from '../api/client';

// Interface base para um Plugin, usada em toda a aplicação
export interface Plugin {
    id: string;
    slug: string;
    name: string;
    authorId: string;
    tagline: string;
    description: string;
    price: number;
    currentVersion: string;
    compatibleVersions: string[];
    mainServerSoftware: string[];
    dependencies: string[];
    iconUrl: string;
    bannerUrl: string;
    rating: number;
    reviewCount: number;
    // --- CORREÇÃO APLICADA AQUI ---
    // Garante que os contadores de compra e download estão na definição principal
    purchaseCount: number;
    downloadCount: number;
    status: 'published' | 'draft' | 'archived';
    isFeatured: boolean;
    categoryIds: number[];
}

interface PluginContextType {
    plugins: Plugin[];
    loading: boolean;
    error: string | null;
}

const PluginContext = createContext<PluginContextType | undefined>(undefined);

export function PluginProvider({ children }: { children: ReactNode }) {
    const [plugins, setPlugins] = useState<Plugin[]>([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState<string | null>(null);

    useEffect(() => {
        async function fetchPlugins() {
            setLoading(true);
            setError(null);
            try {
                // Usa o apiClient para buscar da nova API
                const response = await apiClient.get('/storefront/plugins');
                setPlugins(response.data.plugins || []);
            } catch (err: any) {
                const errorMsg = err.response?.data?.error || 'Falha ao carregar os plugins.';
                setError(errorMsg);
                console.error("Erro ao buscar plugins:", errorMsg);
            } finally {
                setLoading(false);
            }
        }

        fetchPlugins();
    }, []);

    return (
        <PluginContext.Provider value={{ plugins, loading, error }}>
            {children}
        </PluginContext.Provider>
    );
}

export function usePlugins() {
    const context = useContext(PluginContext);
    if (context === undefined) {
        throw new Error('usePlugins must be used within a PluginProvider');
    }
    return context;
}